module.exports = __webpack_public_path__ + "img/logo.e22c6155.svg";